import { render, staticRenderFns } from "./ConnectionsChart.vue?vue&type=template&id=1c3eb900&scoped=true&"
import script from "./ConnectionsChart.vue?vue&type=script&lang=js&"
export * from "./ConnectionsChart.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionsChart.vue?vue&type=style&index=0&id=1c3eb900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3eb900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3eb900')) {
      api.createRecord('1c3eb900', component.options)
    } else {
      api.reload('1c3eb900', component.options)
    }
    module.hot.accept("./ConnectionsChart.vue?vue&type=template&id=1c3eb900&scoped=true&", function () {
      api.rerender('1c3eb900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/connections/ConnectionsChart.vue"
export default component.exports